import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Base url page</h1>
    </div>
  );
}

export default App;
